export default "__VITE_ASSET__CYGuUTxL__"